export enum source {
    WooCommerce = "WooCom",
    Shopify = "Shopify",
    ShipKardo = "Manual",
    SplendidAccounts = "SA",
    Daraz = "Daraz"
}